module.exports = __webpack_public_path__ + "assets/9cfbd2a336750e80ab7dfc3c8252f774.png";